import t, { partial } from '../../../util/translation/translation';

const p = partial('validateErrors');
const validateQuestionaireCategoryForm = (values) => {
  const errors = {};

  if (!values.title) {
    errors.title = `${p('titleFieldCantBeEmpty')}!`;
  }
  if (!values.description) {
    errors.description = `${p('descriptionFieldCantBeEmpty')}!`;
  }

  return errors;
};

export default validateQuestionaireCategoryForm;
